var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNewsPlus = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5833 6.50267H9.74994V5.41211H20.5833V6.50267Z",
    fill: "#002852"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.74994 8.66211H20.5833V9.75267H9.74994V8.66211Z",
    fill: "#002852"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5833 13.0027H9.74994V11.9121H20.5833V13.0027Z",
    fill: "#002852"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1666 16.2527H9.74994V15.1621H15.1666V16.2527Z",
    fill: "#002852"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58688 5.95898V21.1256C7.58688 22.6252 6.37453 23.8376 4.87494 23.8376V22.747C5.77223 22.747 6.49633 22.0229 6.49633 21.1256V5.95898H7.58688Z",
    fill: "#002852"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8369 2.16211H6.4963V5.41211H2.16296V21.1241C2.16296 22.6236 3.37532 23.836 4.87491 23.836H16V22.7454H4.87491C3.97762 22.7454 3.25352 22.0213 3.25352 21.1241V6.50266H7.58685V3.25266H22.7463V16.9993H23.8369V2.16211Z",
    fill: "#002852"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 21H16V20H25V21Z",
    fill: "#002852"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 25V16H21V25H20Z",
    fill: "#002852"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNewsPlus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/news_plus.ecd80ccfbb5417fcd5c1bc266387220b.svg";